import { http, createConfig, createStorage } from '@wagmi/core'
import { metaMask, walletConnect } from '@wagmi/connectors'
import { environment } from '../../../environments/environment'

const projectId = environment.APPKIT_PROJECT_ID;

// Build chains and transports dynamically from environment multi-network config.
// AppKit networks are structurally compatible with wagmi's Chain type, so we cast here.
const rawNetworks = (environment.SUPPORTED_NETWORKS ?? [environment.NETWORK]) as [any, ...any[]];
const chains = rawNetworks;

const rpcMap = environment.RPC_URLS as Record<number, string> | undefined;

const transports = chains.reduce((acc: Record<number, ReturnType<typeof http>>, chain: any) => {
  const rpcUrl = (rpcMap && rpcMap[chain.id]) ?? environment.RPC_URL;
  acc[chain.id] = http(rpcUrl);
  return acc;
}, {} as Record<number, ReturnType<typeof http>>);

export const wagmiConfig = createConfig({
  chains: chains as any,
  connectors: [metaMask(), walletConnect({ projectId })],
  storage: createStorage({ storage: window.localStorage }),
  transports
})